import React from 'react';
import LongText from '../Elements/LongText';
import urlHelper from '../Helpers/urlHelper';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import datetimeHelper from '../Helpers/datetimeHelper.js';
import TpClientInvoiceStatusEnum from '../Enums/ClientInvoiceStatusEnum.js';
import UserNameComponent from '../Elements/UserNameComponent.js';
import ClientInvoiceFormOptionsArray from '../Enums/ClientInvoiceFormOptionsArray.js';
import ClientInvoiceReportGroupOptionsArray from '../Enums/ClientInvoiceReportGroupOptionsArray.js';
import ClientInvoiceReportOrderOptionsArray from '../Enums/ClientInvoiceReportOrderOptionsArray.js';
import JsxHelper from '../Helpers/JsxHelper.js';
import AutomaticInvoiceChip from '../Contents/ThirdParty/Project/InvoiceAutomation/AutomaticInvoiceChip.tsx';

export default class TpClientInvoiceItem {
  constructor(item) {
    if (item === undefined) {
      this.TpClientInvoiceId = null;
      this.CaspianClientId = null;
      this.CaspianClientName = '';
      this.ContactId = null;
      this.BillToContactFirstName = '';
      this.BillToContactLastName = '';
      this.OfficeId = null;
      this.OfficeName = '';
      this.Ponumber = '';
      this.InvoiceNumber = '';
      this.InternalReferenceNumber = '';
      this.FinalizedOnUtc = datetimeHelper.toYYYYsMMsDD(new Date());
      this.DaysToPay = 30;
      this.InvoiceDueOnUtc = datetimeHelper.addDaysToDate(datetimeHelper.toYYYYsMMsDD(new Date()), 45);
      this.Status = TpClientInvoiceStatusEnum.Draft;
      this.Count = 0;
      this.Total = 0;
      this.Paid = 0;
      this.CurrentTotalDue = 0;
      this.Yrmo = null;
      this.CurrencyId = null;
      this.CurrencyCode = '';
      this.LatePaymentInterestRate = 2;
      this.DefaultReportName = '';
      this.ReportGroup1 = '';
      this.ReportGroup2 = '';
      this.ReportOrder = '';
      this.Vatnumber = '';
      this.InvoiceComment = '';
      this.BillToClientName = '';
      this.FulfillmentDate = null;
      this.HasPrepayLines = false;
      this.InvoiceAutomationIsActive = null;
    } else {
      this.TpClientInvoiceId = item.tpClientInvoiceId;
      this.CaspianClientId = item.caspianClientId;
      this.CaspianClientName = item.caspianClientName;
      this.ContactId = item.contactId;
      this.BillToContactFirstName = item.billToContactFirstName ? item.billToContactFirstName : ' ';
      this.BillToContactLastName = item.billToContactLastName ? item.billToContactLastName : ' ';
      this.OfficeId = item.officeId;
      this.OfficeName = item.officeName;
      this.Ponumber = item.ponumber ? item.ponumber : ' ';
      this.InvoiceNumber = item.invoiceNumber ? item.invoiceNumber : ' ';
      this.InternalReferenceNumber = item.internalReferenceNumber ? item.internalReferenceNumber : ' ';
      this.FinalizedOnUtc = item.status !== TpClientInvoiceStatusEnum.Draft ? item.finalizedOnUtc : new Date();
      this.DaysToPay = item.daysToPay;
      this.InvoiceDueOnUtc =
        item.status !== TpClientInvoiceStatusEnum.Draft
          ? datetimeHelper.addDaysToDate(item.finalizedOnUtc, item.daysToPay)
          : datetimeHelper.addDaysToDate(new Date(), item.daysToPay);
      this.Status = item.status;
      this.Count = item.count;
      this.Total = item.total;
      this.Paid = item.paid;
      this.CurrentTotalDue = item.currentTotalDue;
      this.Yrmo = item.yrmo ? item.yrmo : ' ';
      this.CurrencyId = item.currencyId;
      this.CurrencyCode = item.currencyCode;
      this.LatePaymentInterestRate = item.latePaymentInterestRate;
      this.DefaultReportName = item.defaultReportName;
      this.ReportGroup1 = item.reportGroup1 ? item.reportGroup1 : ' ';
      this.ReportGroup2 = item.reportGroup2 ? item.reportGroup2 : ' ';
      this.ReportOrder = item.reportOrder ? item.reportOrder : ' ';
      this.Vatnumber = item.vatnumber ? item.vatnumber : ' ';
      this.InvoiceComment = item.invoiceComment ? item.invoiceComment : ' ';
      this.BillToClientName = item.billToClientName ? item.billToClientName : ' ';
      this.FulfillmentDate = item.fulfillmentDateUtc;
      this.HasPrepayLines = item.hasPrepayLines;
      // Null when a person made the invoice; otherwise whether the automatic invoicing that made it is still Active.
      this.InvoiceAutomationIsActive = item.invoiceAutomationIsActive;

      //Detail Page only
      this.FinalizedBy = item.finalizedBy;
      this.SapinvoiceNumber = item.sapinvoiceNumber ? item.sapinvoiceNumber : ' ';
      this.Version = item.version;
      this.BillToAddressCountry = item.billToAddressCountry ? item.billToAddressCountry : ' ';
      this.BillToAddressState = item.billToAddressState ? item.billToAddressState : ' ';
      this.BillToAddressPostalCode = item.billToAddressPostalCode ? item.billToAddressPostalCode : ' ';
      this.BillToAddressCity = item.billToAddressCity ? item.billToAddressCity : ' ';
      this.BillToAddressLine1 = item.billToAddressLine1 ? item.billToAddressLine1 : ' ';
      this.BillToAddressLine2 = item.billToAddressLine2 ? item.billToAddressLine2 : ' ';
      this.BillToAddressLines =
        (item.billToAddressLine1 ? item.billToAddressLine1 : ' ') +
        (item.billToAddressLine1 && item.billToAddressLine2 ? ', ' : '') +
        (item.billToAddressLine2 ? item.billToAddressLine2 : ' ');
      this.Vat = item.vat;
      this.LateFees = item.lateFees;
    }
    this.Selected = false;
  }

  static DateFields = ['InvoiceDueOnUtc', 'FinalizedOnUtc', 'InvoiceDueOnUtc', 'FulfillmentDate'];

  static MoneyFields = ['Total', 'Paid', 'CurrentTotalDue', 'Vat', 'LateFees'];
  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = ['CurrentTotalDue', 'Vat', 'LateFees'];
  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static nameOfTheItemDetailList() {
    return 'Third-Party Client Invoice';
  }

  static FieldsToShowInListTable = [
    {
      data: [
        { name: '-message-', label: 'General Information', className: 'text-left' },

        { label: 'Client', name: 'CaspianClientName', className: 'text-left' },
        {
          label: 'Finalized By',
          name: (item) => <UserNameComponent userId={item.FinalizedBy} />,
          className: 'text-left',
        },
        { label: 'Days To Pay', name: 'DaysToPay', className: 'text-left' },

        {
          label: 'Bill To Contact',
          name: (item) => `${item.BillToContactFirstName} ${item.BillToContactLastName}`,
          className: 'text-left',
        },
        {
          label: 'Finalized On',
          name: 'FinalizedOnUtc',
          className: 'text-left',
        },
        {
          label: 'Due On',
          name: 'InvoiceDueOnUtc',
          className: 'text-left',
        },

        { label: 'Revenue Period', name: 'Yrmo', className: 'text-left' },
        { label: 'Office', name: 'OfficeName', className: 'text-left' },
        {
          label: 'Fulfillment Date',
          name: 'FulfillmentDate',
          className: 'text-left',
          condition: { field: 'OfficeName', value: 'BARE Hungary' },
        },

        {
          label: 'Status',
          name: 'Status',
          className: 'text-left',
        },
        { label: 'Late Fee %', name: 'LatePaymentInterestRate', className: 'text-left' },
        { label: 'Version', name: 'Version', className: 'text-left' },

        { name: '-message-', label: 'Invoice Details', className: 'text-left' },

        { label: 'Bare Invoice #', name: 'TpClientInvoiceId', className: 'text-left' },
        { label: 'Purchase Order #', name: 'Ponumber', className: 'text-left' },
        {
          label: 'Form Order',
          name: (item) => TpClientInvoiceItem.GetGetFormOrderLabel(item.ReportOrder),
          className: 'text-left',
        },

        { label: 'Client Invoice #', name: 'InvoiceNumber', className: 'text-left' },
        { label: 'Internal Reference #', name: 'InternalReferenceNumber', className: 'text-left' },
        {
          label: 'Form Group 1',
          name: (item) => TpClientInvoiceItem.GetFormGroupLabel(item.ReportGroup1),
          className: 'text-left',
        },

        { label: 'SAP Invoice #', name: 'SapinvoiceNumber', className: 'text-left' },
        {
          label: 'Invoice Form',
          name: (item) => TpClientInvoiceItem.GetInvoiceFormLabel(item.DefaultReportName),
          className: 'text-left',
        },
        {
          label: 'Form Group 2',
          name: (item) => TpClientInvoiceItem.GetFormGroupLabel(item.ReportGroup2),
          className: 'text-left',
        },

        {
          label: 'Invoice Comments',
          name: 'InvoiceComment',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },

        { name: '-message-', label: 'Billing Details', className: 'text-left' },

        { label: 'Bill To Client Tax #', name: 'Vatnumber', className: 'text-left' },
        { label: 'First Name', name: 'BillToContactFirstName', className: 'text-left' },
        { label: '', name: '', className: 'text-left' },

        { label: 'Bill To Client Name', name: 'BillToClientName', className: 'text-left' },
        { label: 'Last Name', name: 'BillToContactLastName', className: 'text-left' },
        { label: '', name: '', className: 'text-left' },

        { label: 'Country', name: 'BillToAddressCountry', className: 'text-left' },
        { label: 'State', name: 'BillToAddressState', className: 'text-left' },
        { label: 'Postal Code', name: 'BillToAddressPostalCode', className: 'text-left' },

        { label: 'City', name: 'BillToAddressCity', className: 'text-left' },
        {
          label: 'Address',
          name: 'BillToAddressLines',
          className: 'text-left',
        },
        { label: '', name: '', className: 'text-left' },

        { name: '-message-', label: 'Billing Total', className: 'text-left' },

        { label: 'Currency', name: 'CurrencyCode', className: 'text-left' },
        { label: 'Amount Due', name: 'CurrentTotalDue', className: 'text-left' },
        { label: 'Tax', name: 'Vat', className: 'text-left' },

        { label: 'Late Fees', name: 'LateFees', className: 'text-left' },
        { label: '', name: '', className: 'text-left' },
        { label: '', name: '', className: 'text-left' },
      ],
    },
  ];

  static GetInvoiceFormLabel(invoiceForm) {
    if (!invoiceForm) return '';
    return ClientInvoiceFormOptionsArray.find((i) => i.value === invoiceForm)?.label ?? ' ';
  }

  static GetFormGroupLabel(formGroup) {
    if (!formGroup) return '';
    return ClientInvoiceReportGroupOptionsArray.find((i) => i.value === formGroup)?.label ?? ' ';
  }

  static GetGetFormOrderLabel(formOrder) {
    if (!formOrder) return '';
    return ClientInvoiceReportOrderOptionsArray.find((i) => i.value === formOrder)?.label ?? ' ';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: TpClientInvoiceItem.getSelectedCellHeader,
        orderById: '',
        data: TpClientInvoiceItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Bare Invoice #',
        orderById: 'TpClientInvoiceId',
        data: TpClientInvoiceItem.GetDetailCellContent,
        minWidth: 20,
      },
      {
        label: 'Client Name (Caspian Client ID)',
        orderById: 'CaspianClientName',
        data: TpClientInvoiceItem.getCaspianClientNameCellContent,
        minWidth: 50,
      },
      {
        label: 'Bill To Contact',
        orderById: 'CiBillToContact',
        data: TpClientInvoiceItem.getBillToContactCellContent,
        minWidth: 40,
      },
      { label: 'Office', orderById: 'OfficeName', data: 'OfficeName', minWidth: 25 },
      { label: 'PO #', orderById: 'Ponumber', data: TpClientInvoiceItem.getPoNumberCellContent, minWidth: 20 },
      {
        label: 'Client Invoice #',
        orderById: 'InvoiceNumber',
        data: TpClientInvoiceItem.getInvoiceNumberCellContent,
        minWidth: 20,
      },
      {
        label: 'Internal Reference',
        orderById: 'InternalReferenceNumber',
        data: TpClientInvoiceItem.getInternalReferenceCellContent,
        minWidth: 30,
      },
      { label: 'Invoiced On', orderById: 'FinalizedOnUtc', data: 'FinalizedOnUtc', minWidth: 20 },
      { label: 'Due Date', orderById: 'InvoiceDueOnUtc', data: 'InvoiceDueOnUtc', minWidth: 20 },
      {
        label: 'Status',
        orderById: 'Status',
        data: 'Status',
        minWidth: 20,
      },
      { label: 'Made By', orderById: '', data: TpClientInvoiceItem.getMadeByCellContent, minWidth: 20 },
      { label: 'Invoice Line #', orderById: 'Count', data: 'Count', minWidth: 10 },
      {
        label: 'Has Prepay',
        orderById: 'HasPrepayLines',
        data: (item) => JsxHelper.YesNo(item.HasPrepayLines),
        minWidth: 10,
      },
      { label: 'Total', orderById: 'Total', data: 'Total', minWidth: 20 },
      { label: 'Applied Amount', orderById: 'Paid', data: 'Paid', minWidth: 20 },
      { label: 'Current Due', orderById: 'CurrentTotalDue', data: 'CurrentTotalDue', minWidth: 20 },
      { label: 'YRMO', orderById: 'Yrmo', data: 'Yrmo', minWidth: 10 },
      {
        label: ' ',
        orderById: '',
        data: TpClientInvoiceItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={TpClientInvoiceItem.selectedStatus()}
        onChange={(e) => {
          TpClientInvoiceItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          TpClientInvoiceItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static selectedStatus() {
    return false;
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.TpClientInvoiceId,
      '',
      '',
      'tpclientinvoicedetails',
      `id=${item.TpClientInvoiceId}`,
      'Open up in a new tab'
    );
  }

  static getCaspianClientNameCellContent(item) {
    return (
      <LongText
        text={item.CaspianClientId ? `${item.CaspianClientName} (${item.CaspianClientId})` : ' '}
        maxLength={40}
      />
    );
  }
  static getBillToContactCellContent(item) {
    return (
      <LongText
        text={`${item.BillToContactFirstName} ${item.BillToContactLastName}`}
        maxLength={30}
      />
    );
  }

  static getInvoiceNumberCellContent(item) {
    return (
      <LongText
        text={item.InvoiceNumber ? item.InvoiceNumber : ' '}
        maxLength={20}
      />
    );
  }

  static getPoNumberCellContent(item) {
    return (
      <LongText
        text={item.Ponumber ? item.Ponumber : ' '}
        maxLength={15}
      />
    );
  }

  static getMadeByCellContent(item) {
    return <AutomaticInvoiceChip isActive={item.InvoiceAutomationIsActive} />;
  }

  static getInternalReferenceCellContent(item) {
    return (
      <LongText
        text={item.InternalReferenceNumber ? item.InternalReferenceNumber : ' '}
        maxLength={25}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            iconName: 'fa-solid fa-edit',
            roleKey: 'tpclientinvoices_edit',
            onClick: () => TpClientInvoiceItem.editFunction(item.TpClientInvoiceId, item),
            disabled: item.Status === TpClientInvoiceStatusEnum.Cancelled,
          },
          {
            text: 'Cancel Invoice',
            iconName: 'fa-solid fa-file-circle-xmark',
            roleKey: 'tpclientinvoices_edit',
            onClick: () => TpClientInvoiceItem.cancelFunction(item.TpClientInvoiceId, item),
            disabled: item.Status !== TpClientInvoiceStatusEnum.Draft,
          },
          {
            text: 'Finalize Invoice',
            iconName: 'fa-solid fa-check',
            roleKey: 'tpclientinvoices_edit',
            onClick: () => TpClientInvoiceItem.finalizeFunction(item.TpClientInvoiceId, item),
            disabled: item.Total < 0 || item.Status !== TpClientInvoiceStatusEnum.Draft,
          },
          {
            text: 'Create Third-Party Credit Memo',
            iconName: 'fa-solid fa-credit-card',
            roleKey: 'tpcreditmemo_createandmodifycredit',
            onClick: () => TpClientInvoiceItem.createCreditMemoFunction(item.TpClientInvoiceId, item),
            disabled: item.CurrentTotalDue <= 0 || item.Status !== TpClientInvoiceStatusEnum.Finalized,
          },
          {
            text: 'Third-Party Credit Memos',
            iconName: 'fa-solid fa-credit-card',
            roleKey: `tpcreditmemos_view`,
            url: `/tpcreditmemo/search?TpClientInvoiceId=${item.TpClientInvoiceId}`,
            title: 'Third-Party Credit Memos',
            disabled: false,
          },
          {
            text: 'Copy',
            iconName: 'fa-regular fa-copy',
            roleKey: 'tpclientinvoices_create',
            onClick: () => TpClientInvoiceItem.copyFunction(item.TpClientInvoiceId, item),
            disabled: !item.Status, //!item.CiStatusCode
          },
        ]}
      />
    );
  }

  static editFunction(id, item) {
    alert('Empty function!');
  }
  static cancelFunction(id, item) {
    alert('Empty function!');
  }
  static finalizeFunction(id, item) {
    alert('Empty function!');
  }
  static createCreditMemoFunction(id, item) {
    alert('Empty function!');
  }
  static copyFunction(id, item) {
    alert('Empty function!');
  }
}
